import { PINTEREST } from '@/lib/socialProfile';

export const TYPE_IMAGE = 'image';
export const TYPE_VIDEO = 'video';
export const TYPE_CAROUSEL = 'carousel';
export const TYPE_STATUS = 'status';
export const TYPE_STORY = 'story';
export const TYPE_REEL = 'reel';
export const TYPE_GIF = 'gif';
export const TYPE_DOCUMENT = 'document';
export const TYPE_SHORT = 'short';
export const TYPE_MULTIPLE_IMAGES = 'multiple_images';
export const TYPE_MULTIPLE_MIXED = 'multiple_mixed';
export const TYPE_MULTIPLE_VIDEOS = 'multiple_videos';

export const POST_TYPE = {
    [TYPE_IMAGE]: {
        icon: 'content',
        background: 'bg-icoBlue-100 dark:bg-icoBlue/20',
        color: 'text-icoBlue',
        text: { default: 'commons:photo', [PINTEREST]: 'commons:image' }
    },
    [TYPE_VIDEO]: {
        icon: 'video',
        background: 'bg-icoPurple-100 dark:bg-icoPurple/20',
        color: 'text-icoPurple',
        text: { default: 'commons:video' }
    },
    [TYPE_CAROUSEL]: {
        icon: 'carousel',
        background: 'bg-icoGreen-100 dark:bg-icoGreen/20',
        color: 'text-icoGreen',
        text: { default: 'commons:carousel' }
    },
    [TYPE_STATUS]: {
        icon: 'text',
        background: 'bg-icoAquaBlue-100 dark:bg-icoAquaBlue/20',
        color: 'text-icoAquaBlue',
        text: { default: 'commons:status_scheduler' }
    },
    [TYPE_STORY]: {
        icon: 'story',
        background: 'bg-icoPurple-100 dark:bg-icoPurple/20',
        color: 'text-icoPurple',
        text: { default: 'commons:story' }
    },
    [TYPE_REEL]: {
        icon: 'reel',
        background: 'bg-icoBlue-100 dark:bg-icoBlue/20',
        color: 'text-icoBlue',
        text: { default: 'commons:reel' }
    },
    [TYPE_GIF]: {
        icon: 'content',
        background: 'bg-icoPink-100 dark:bg-icoPink/20',
        color: 'text-icoPink',
        text: { default: 'commons:posts.gif' }
    },
    [TYPE_DOCUMENT]: {
        icon: 'document',
        background: 'bg-icoPink-100 dark:bg-icoPink/20',
        color: 'text-icoPink',
        text: { default: 'commons:document' }
    },
    [TYPE_SHORT]: {
        icon: 'story',
        background: 'bg-icoPurple-100 dark:bg-icoPurple/20',
        color: 'text-icoPurple',
        text: { default: 'commons:short' }
    },
    [TYPE_MULTIPLE_IMAGES]: {
        icon: 'carousel',
        background: 'bg-icoGreen-100 dark:bg-icoGreen/20',
        color: 'text-icoGreen',
        text: { default: 'commons:multiple_images' }
    },
    [TYPE_MULTIPLE_MIXED]: {
        icon: 'carousel',
        background: 'bg-icoGreen-100 dark:bg-icoGreen/20',
        color: 'text-icoGreen',
        text: { default: 'commons:multiple_mixed' }
    },
    [TYPE_MULTIPLE_VIDEOS]: {
        icon: 'carousel',
        background: 'bg-icoGreen-100 dark:bg-icoGreen/20',
        color: 'text-icoGreen',
        text: { default: 'commons:multiple_videos' }
    }
} as const;

export type PostTypeType = {
    [K in keyof typeof POST_TYPE]: K;
}[keyof typeof POST_TYPE];
